import { Pagination } from 'core/pagination/Pagination';

export type ProductWithPagination = {
  pagination: Pagination,
  products: Product[]
};

export type Product = {
  productId: string;
  name: string;
  category: string;
  listPrice: number;
  imgLink: string;
  multipack: number;
  vendorNumber?: string;
  adServingUrl?: string;
  availability: ProductAvailability;
  visibility?: string;
  stockType?: string;
};

export enum ProductAvailability {
  IN_STOCK = 'in_stock',
  OUT_OF_STOCK = 'out_of_stock'
}

export enum ProductVisibility {
  HIDDEN = 'hidden'
}

export type SavedTargetingProductSku = {
  skuId: string;
  description: string;
  brand: string;
} & Product;

export enum KeywordTag {
  ORIGINAL = 'ORIGINAL',
  POPULAR = 'POPULAR',
  BOTH = 'BOTH'
}

export enum KeywordSource {
  MANUAL = 'USER_SELECTED',
  SYSTEM = 'SYSTEM_RECOMMEND',
  TRENDING = 'RECENT_POPULAR',
  PROPOSAL = 'KEYWORD_PROPOSAL'
}

export type SuggestKeywords = {
  suggestKeyword: string,
  bidPrice: number,
  maxCpc: number,
  // 該字在後端 CPC 保留期內「有點擊的天數」，也是建議出價下限那個加權平均的權重。
  // 0 代表後端的 CPC cache 裡沒有這個字 —— 此時 bidPrice / maxCpc 是 fallback 常數而非真實資料。
  cpcCounts: number,
  keywordSearchVolume: number,
  last7DayGrowthRate: number,
  last30DayGrowthRate: number,
  keywordAdCompetition: number,
  keywordVersion: string,
  keywordTag?: KeywordTag,
  sources: KeywordSource[]
};

export const MAX_TOTAL_KEYWORDS = 100;

/**
 * 手上還沒有成效資料的關鍵字列。
 *
 * 兩個消費端共用這一份：`優化目標` 的已選清單在使用者手輸入 / 從 limitation 重建時建它，
 * `基本資訊` 的「出價效益參考」卡片在手上沒有該字的成效列時也建它 —— 卡片必須把使用者
 * 選過的字全部列出來，缺資料是「這一列顯示不出真實數字」，不是「這個字不存在」。
 *
 * `cpcCounts` 為 0 是這一列唯一有意義的訊號（顯示端會換成預設區間 8–20，
 * 見 `core/pchome/KeywordBidCompetitiveness.resolveKeywordBidRange`）。
 * 各建一份就會漂：漏掉某一個 0 欄位，畫面會拿到假的判定結果。
 */
export const createUnresolvedKeywordRow = (
  suggestKeyword: string,
  sources: KeywordSource[]
): SuggestKeywords => ({
  suggestKeyword,
  bidPrice: 0,
  maxCpc: 0,
  cpcCounts: 0,
  keywordSearchVolume: 0,
  last7DayGrowthRate: 0,
  last30DayGrowthRate: 0,
  keywordAdCompetition: 0,
  keywordVersion: '',
  sources
});

export type CategoryData = {
  [key: string]: CategoryData | {};
};
